import { uncoveredSalesChannelWarningSchema } from "@redotech/redo-model/sales-channels";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getUncoveredSalesChannelWarnings = {
  name: "getUncoveredSalesChannelWarnings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({ warnings: z.array(uncoveredSalesChannelWarningSchema) }),
};

export { uncoveredSalesChannelWarningSchema as adminUncoveredSalesChannelWarningSchema } from "@redotech/redo-model/sales-channels";
